// removed by extract-text-webpack-plugin
module.exports = {"descriptionInput":"description__descriptionInput__2QtlA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TransactionList/Columns/Description/description.css
// module id = 1650
// module chunks = 0